import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'header-test',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
